import {createStore} from './create-store'

export const localStorageStore = createStore('localStorage')
